import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { FiFile, FiImage, FiUpload } from 'react-icons/fi';

import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '@/components/button/button-component';

import { BodyText } from '@/utils/global-fonts';
import Styled from './file-upload-style';

const fileIconStyle = { fontSize: '40px', fontWeight: 'bold' };
const fileImageStyle = { fontSize: '30px', fontWeight: 'bold' };

const bodyTextStyle = { marginTop: '0px' };
const dragBodyTextStyle = { fontSize: '10px' };

/**
 * @param {object} props - The props object
 * @returns {JSX.Element} - The rendered component
 */
const FileUpload = (props) => {
  const {
    // File props
    fileType,
    onDrop,
    fileName,
    isDropped,
    maxNumberFiles,
  } = props;
  // xlsx or text
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/xlsx': ['.xlsx'] },
    multiple: maxNumberFiles === 0 || maxNumberFiles > 1, // Ensure this is true for maxFiles to work
    maxFiles: maxNumberFiles,
  });

  return (
    <Styled.Div>
      <Styled.DropZone
        isDropped={isDropped}
        data-cy="dzFileUpload"
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <Styled.DropHere>
            <BodyText>Drop the files here ...</BodyText>
          </Styled.DropHere>
        ) : (
          <Styled.Div>
            {isDropped ? (
              <>
                <FiFile style={fileIconStyle} />
                <BodyText>{fileName}</BodyText>
                <BodyText style={bodyTextStyle}>or</BodyText>
                <PrimaryOutlineButton
                  buttonWidth="108px"
                  type="button"
                  loading={false}
                  icon={<FiUpload />}
                  title="Browse"
                  onClick={() => {}}
                  margin="0 0 0 0"
                />
              </>
            ) : (
              <>
                <FiImage style={fileImageStyle} />
                <BodyText>{`Drag ${fileType} file here to upload from your device`}</BodyText>
                <BodyText
                  style={dragBodyTextStyle}
                >{`Only *.${fileType} files will be accepted`}</BodyText>
                <BodyText style={bodyTextStyle}>or</BodyText>
                <PrimaryButton
                  buttonWidth="108px"
                  type="button"
                  icon={<FiUpload />}
                  loading={false}
                  title="Browse"
                  onClick={() => {}}
                />
              </>
            )}
          </Styled.Div>
        )}
      </Styled.DropZone>
    </Styled.Div>
  );
};

FileUpload.defaultProps = {
  // File props
  fileName: '',
  setFileName: undefined,
  isDropped: false,
  setIsDropped: undefined,
  maxNumberFiles: 0,
};

FileUpload.propTypes = {
  // File props
  fileType: PropTypes.string.isRequired,
  acceptedFileType: PropTypes.string.isRequired,
  onDrop: PropTypes.func.isRequired,
  fileName: PropTypes.string,
  setFileName: PropTypes.func,
  isDropped: PropTypes.bool,
  setIsDropped: PropTypes.func,
  maxNumberFiles: PropTypes.number,
};

export default FileUpload;
